import type { MerchantApi } from "./api";

export async function subscribeMerchantWebPush(api: MerchantApi): Promise<void> {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return;
  const key = await api.notificationPushKey();
  if (!key.enabled || !key.publicKey) return;
  const registration = await navigator.serviceWorker.ready;
  const subscription = await registration.pushManager.subscribe({
    applicationServerKey: urlBase64ToUint8Array(key.publicKey),
    userVisibleOnly: true,
  });
  const json = subscription.toJSON();
  if (!json.endpoint || !json.keys?.auth || !json.keys.p256dh) return;
  await api.registerNotificationDevice({
    platform: "web_push",
    subscription: {
      endpoint: json.endpoint,
      keys: { auth: json.keys.auth, p256dh: json.keys.p256dh },
    },
    userAgent: navigator.userAgent.slice(0, 300),
  });
}

function urlBase64ToUint8Array(value: string): Uint8Array<ArrayBuffer> {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, "+").replace(/_/g, "/");
  return Uint8Array.from(atob(base64), (char) => char.charCodeAt(0));
}
